// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  rowId: __t.u64().primaryKey().name("row_id"),
  playerId: __t.string().name("player_id"),
  ruleset: __t.string(),
  territoryId: __t.string().name("territory_id"),
  status: __t.string(),
  matchedMatchId: __t.option(__t.string()).name("matched_match_id"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
